<template>
  <span> {{ formatMoney(value) }}</span>
</template>
<script lang="ts" setup>
  import { formatMoney } from '@shared/services/format.service';

  export interface Props {
    value: number;
  }
  defineProps<Props>();
</script>
